/**
 * Combined Listing scroller: families of more than 3 products render as one
 * swipeable row (snippets/combined-listing.liquid). This element shows the arrow
 * buttons only on the side that has more tiles, pages the row on click, and makes
 * sure the current product's tile is visible on load.
 * Without JS the row still scrolls by swipe; the arrows simply stay hidden.
 */
if (!customElements.get('ocl-scroller')) {
  customElements.define(
    'ocl-scroller',
    class OclScroller extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.ocl__list');
        this.prevButton = this.querySelector('.ocl__nav--prev');
        this.nextButton = this.querySelector('.ocl__nav--next');
        if (!this.list || !this.prevButton || !this.nextButton) return;

        this.update = this.update.bind(this);
        this.onPrev = () => this.page(-1);
        this.onNext = () => this.page(1);
        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);
        this.list.addEventListener('scroll', this.update, { passive: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.list);
        }

        this.revealSelected();
        this.update();
      }

      disconnectedCallback() {
        if (!this.list) return;
        this.prevButton.removeEventListener('click', this.onPrev);
        this.nextButton.removeEventListener('click', this.onNext);
        this.list.removeEventListener('scroll', this.update);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      /** Center the current product's tile when it starts outside the visible row. */
      revealSelected() {
        const selected = this.list.querySelector('.ocl__thumb--selected');
        if (!selected) return;
        const listRect = this.list.getBoundingClientRect();
        const rect = selected.getBoundingClientRect();
        if (rect.left >= listRect.left && rect.right <= listRect.right) return;
        const left = rect.left - listRect.left + this.list.scrollLeft;
        // scrollLeft (not scrollIntoView) so the page itself never jumps
        this.list.scrollLeft = Math.max(0, left - (this.list.clientWidth - rect.width) / 2);
      }

      page(direction) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.list.scrollBy({
          left: direction * this.list.clientWidth * 0.8,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      update() {
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        const x = this.list.scrollLeft;
        this.prevButton.hidden = x <= 1;
        this.nextButton.hidden = maxScroll <= 1 || x >= maxScroll - 1;
      }
    }
  );
}
